module.exports = __webpack_public_path__ + "static/media/check_icon.0645e8c5.svg";